export const ServicesBannerComerciales = [
    {
        titleLine1: "SOMOS LA ALTERNATIVA MÁS EFICIENTE PARA REALIZAR SU PROYECTO",
        // titleLine2: "",
        highlight: "¡CONTÁCTENOS Y EVITE EL USO DE ANDAMIOS!",
        description: "Solo envíe un mensaje con la descripción del servicio que desea que realicemos para ofrecerle una cotización personalizada.",
        buttonText: "SERVICIO PERSONALIZADO",
        buttonLink: "/contacto",
        backgroundColor: "#FFCD00"
    }
];


export const ServicesBannerComercialesEn = [
    {
        titleLine1: "WE ARE THE MOST EFFICIENT ALTERNATIVE TO EXECUTE YOUR",
        titleLine2: "PROJECT",
        highlight: "CONTACT US AND AVOID USING SCAFFOLDING!",
        description: "Just send a message with the description of the service you need, and we will provide you with a personalized quote.",
        buttonText: "CUSTOM SERVICE",
        buttonLink: "/contacto",
        backgroundColor: "#FFCD00"
    }
];

